import React from 'react';
import { reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import PropTypes from 'prop-types';
import { IcepackFillerFormView } from './icepack-filler-view';
import { getFormInitialValuesSelector } from '../../selectors';
import { ICEPACK_FILLER_FORM_NAME } from '../../constants';
import { validate } from '../../utils';

const IcepackFillerFormWrapper = ({ isLoading }) => {
	return <IcepackFillerFormView isLoading={isLoading} />;
};

const withForm = reduxForm({
	form: ICEPACK_FILLER_FORM_NAME,
	enableReinitialize: true,
	onSubmit: validate,
})(IcepackFillerFormWrapper);

const mapStateToProps = createStructuredSelector({
	initialValues: getFormInitialValuesSelector(),
});

IcepackFillerFormWrapper.propTypes = {
	initialValues: PropTypes.object,
	isLoading: PropTypes.bool.isRequired,
};

const IcepackFillerForm = connect(mapStateToProps)(withForm);

export { IcepackFillerForm };
